import {hashCodeCertificate} from "./hoc/hashCodeCertificate";


const WaybillV2ConsignorCancel = hashCodeCertificate("WaybillV2ConsignorCancel")

export default WaybillV2ConsignorCancel
